import React, { useState } from "react";
import ConfirmationModal from "./ConfirmationModal";

export default function TermsModal({accepted: acceptedInit, url, onAccept}) {
  const [accepted, setAccepted] = useState(acceptedInit)

  async function onAcceptTerms() {
    onAccept(setAccepted)
  }

  return (
    <ConfirmationModal
      title="Aktualisierte AGBs"
      primaryActionCaption="Zustimmen"
      primaryActionFn={onAcceptTerms}
      secondaryActionCaption={false}
      visible={!accepted}
    >
      <p>
        Wir haben unserer Allgemeinen Geschäftsbedingungen aktualisiert.
        Um die Plattform weiterhin nutzen zu können ist eine Zustimmung erforderlich.
      </p>
      <p>
        <a href={url} target="_blank" rel="noreferrer">Allgemeine Geschäftsbedingungen EDEKA StartHub</a>
      </p>
    </ConfirmationModal>
  )
}
